import { render, staticRenderFns } from "./configurations.vue?vue&type=template&id=5eec30e8"
import script from "./configurations.vue?vue&type=script&lang=js"
export * from "./configurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/app/components/img.vue').default,Img: require('/app/components/img.vue').default,Loader: require('/app/components/loader.vue').default,Configurations: require('/app/components/configurations.vue').default,ProductDetails: require('/app/components/product/details.vue').default})
